import { render } from "./About.vue?vue&type=template&id=e6d1ce44&scoped=true&bindings={\"trans\":\"options\",\"store\":\"setup\"}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e6d1ce44"

export default script